import { render } from "./EditPpt.vue?vue&type=template&id=13da6168"
import script from "./EditPpt.vue?vue&type=script&lang=js"
export * from "./EditPpt.vue?vue&type=script&lang=js"
script.render = render

export default script